import AOS from 'aos';

'use strict';
const aos = {
	init: function() {
		setTimeout(() => {
			AOS.init({
				once: true,
				offset: -30,
				duration: 600,
			});
		}, 50);
	},
};

export default aos;
